// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import NotificationsController from "./notifications_controller";
application.register("notifications", NotificationsController);

import FullscreenController from "./fullscreen_controller";
application.register("fullscreen", FullscreenController);

import streamController from "./stream_controller";
application.register("stream", streamController);

import LineChartController from "./line_chart_controller";
application.register("line-chart", LineChartController);

import ChartButtonsController from "./chart_buttons_controller";
application.register("chart-buttons", ChartButtonsController);
